import {createSelector} from 'reselect';
import detectCardType from '../../validation/detectCardType';

export const getNewCardDetails = state => state.payment.newCardDetails;

export const getCardType = createSelector(
  [getNewCardDetails],
  (newCardDetail) => {
    if (newCardDetail.creditCardNumber && newCardDetail.creditCardNumber.length >= 6) {
      return detectCardType(newCardDetail.creditCardNumber);
    }
    return {iconName: ''};
  },
);
